import { EntityStaff } from "../../entity/EntityStaff";

export class DtoStaffsPostRes extends EntityStaff {}
